(() => {
  'use strict';

  if (window.ENTINAPromotionAnnouncement?.init) {
    window.ENTINAPromotionAnnouncement.init(document);
    return;
  }

  const instances = new WeakMap();
  const isDesignMode = () => Boolean(window.Shopify?.designMode);

  const read = (key) => {
    try { return JSON.parse(window.localStorage.getItem(key) || 'null'); }
    catch (_) { return null; }
  };

  const write = (key, value) => {
    try { window.localStorage.setItem(key, JSON.stringify(value)); }
    catch (_) {}
  };

  const pad = (value) => String(value).padStart(2, '0');

  const setHidden = (bar, hidden) => {
    bar.hidden = hidden;
    const wrapper = bar.closest('.shopify-section');
    if (wrapper) wrapper.classList.toggle('epa-section-hidden', hidden);
  };

  const getBars = (root = document) => {
    const bars = [];
    if (root?.matches?.('[data-entina-promotion-announcement]')) bars.push(root);
    if (root?.querySelectorAll) bars.push(...root.querySelectorAll('[data-entina-promotion-announcement]'));
    return [...new Set(bars)];
  };

  const destroy = (bar) => {
    const state = instances.get(bar);
    if (!state) return;
    if (state.timerId !== null) window.clearInterval(state.timerId);
    if (state.closeButton && state.closeHandler) state.closeButton.removeEventListener('click', state.closeHandler);
    instances.delete(bar);
  };

  const start = (bar) => {
    if (!bar || instances.has(bar)) return;

    const state = { timerId: null, closeButton: bar.querySelector('[data-close-announcement]'), closeHandler: null };
    instances.set(bar, state);
    setHidden(bar, false);

    const endAtRaw = (bar.dataset.countdownEndAt || '').trim();
    const endAt = Date.parse(endAtRaw);
    const campaignKey = (bar.dataset.campaignKey || '').trim() || endAtRaw || 'default';
    const dismissKey = `entina:promotion-announcement:${bar.dataset.sectionId}:${campaignKey}:dismissed`;
    const rememberClose = bar.dataset.rememberClose !== 'false';
    const countdownEnabled = bar.dataset.countdownEnabled !== 'false';
    const expiredBehavior = bar.dataset.expiredBehavior || 'keep_zero';

    const fields = {
      days: bar.querySelector('[data-countdown-days]'),
      hours: bar.querySelector('[data-countdown-hours]'),
      minutes: bar.querySelector('[data-countdown-minutes]'),
      seconds: bar.querySelector('[data-countdown-seconds]')
    };

    state.closeHandler = () => {
      setHidden(bar, true);
      if (rememberClose && !isDesignMode()) write(dismissKey, { dismissed: true, at: Date.now() });
    };
    state.closeButton?.addEventListener('click', state.closeHandler);

    const dismissed = read(dismissKey);
    const wasDismissed = dismissed === true || dismissed?.dismissed === true;
    if (rememberClose && wasDismissed && !isDesignMode()) {
      setHidden(bar, true);
      return;
    }

    if (!countdownEnabled) return;
    if (!Number.isFinite(endAt)) {
      bar.dataset.countdownInvalid = 'true';
      return;
    }

    const render = (remainingMs) => {
      const remaining = Math.max(0, remainingMs);
      const values = {
        days: Math.floor(remaining / 86400000),
        hours: Math.floor((remaining % 86400000) / 3600000),
        minutes: Math.floor((remaining % 3600000) / 60000),
        seconds: Math.floor((remaining % 60000) / 1000)
      };
      Object.entries(values).forEach(([unit, value]) => {
        if (fields[unit]) fields[unit].textContent = pad(value);
      });
    };

    const stopTimer = () => {
      if (state.timerId !== null) {
        window.clearInterval(state.timerId);
        state.timerId = null;
      }
    };

    const update = () => {
      const remaining = endAt - Date.now();
      if (remaining <= 0) {
        render(0);
        bar.dataset.countdownExpired = 'true';
        stopTimer();
        if (expiredBehavior === 'hide' && !isDesignMode()) setHidden(bar, true);
        return;
      }
      delete bar.dataset.countdownExpired;
      render(remaining);
    };

    update();
    if (endAt > Date.now()) state.timerId = window.setInterval(update, 1000);
  };

  const init = (root = document) => getBars(root).forEach(start);
  const unload = (root) => getBars(root).forEach(destroy);

  window.ENTINAPromotionAnnouncement = { version: '2.0.0', init, unload };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => unload(event.target));
  document.addEventListener('shopify:section:select', (event) => {
    if (!isDesignMode()) return;
    getBars(event.target).forEach((bar) => setHidden(bar, false));
  });
})();